module.exports = __webpack_public_path__ + "static/media/Tie-Rod.0895d45b.JPG";